import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { AdvancedQualification, QualificationCategory } from '@ps/survey-utils';

import {
  GetAdvancedTargetingQuestionsResponseDto,
  QualificationCategoriesResponseDto,
} from './dtos/advanced-qualification.dto';
import { QualificationCategoryMapper } from './mappers/qualification-category.mapper';
import { AdvancedQualificationMapper } from './mappers/advanced-qualification.mapper';
import { AdvancedQualificationsPayloadMapper } from './mappers/advanced-qualification.payload.mapper';
import { withLoading } from '@ps/core-loading';

@Injectable({ providedIn: 'root' })
export class AdvancedQualificationApi {
  private readonly _http = inject(HttpClient);
  private readonly _env = inject(ENV_CONFIG);

  private readonly _mapper = new AdvancedQualificationMapper();
  private readonly _payloadMapper = new AdvancedQualificationsPayloadMapper();
  private readonly _categoryMapper = new QualificationCategoryMapper();

  private readonly _baseUrl = this._env.pureSpectrum.url;
  private readonly _attributesUrl = `${this._baseUrl}/buyers/v3/attributes`;
  private readonly _advancedQuestionsUrl = `${this._baseUrl}/questions/v2/advance`;

  public getQuestions(
    search: string,
    categoryIds: number[],
  ): Observable<AdvancedQualification[]> {
    const params = new HttpParams({
      fromObject: this._payloadMapper.toPayload({ search, categoryIds }),
    });

    return this._http
      .get<GetAdvancedTargetingQuestionsResponseDto>(
        this._advancedQuestionsUrl,
        { params, context: withLoading('drawer') },
      )
      .pipe(map((response) => this._mapper.fromDtoList(response.questions)));
  }

  public categories(): Observable<QualificationCategory[]> {
    return this._http
      .get<QualificationCategoriesResponseDto>(
        `${this._attributesUrl}/categories/all`,
        { context: withLoading('drawer') },
      )
      .pipe(map((response) => this._categoryMapper.fromDtoList(response)));
  }
}
